import { useMeeting, useParticipant } from "@videosdk.live/react-sdk";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "../PD/pd.module.css";
import { useBorrowerContext } from "../../../../../../store/borrower-details";
import axios from 'axios';
import { url } from "../../../../../../../../../App";
import Cookies from 'js-cookie';
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import NoPhotographyIcon from '@mui/icons-material/NoPhotography';
import Tooltip from '@mui/material/Tooltip';
import React, { useState, useEffect, useRef } from 'react';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { createCameraVideoTrack } from "@videosdk.live/react-sdk";
// import { Flag } from "@mui/icons-material";

export default function Controls({ loanID }) {
  const { borrowerData } = useBorrowerContext();
  const fetchedBorrowerDetails = borrowerData.borrower;

  const { leave, toggleMic, toggleWebcam, localParticipant, participants } = useMeeting({
    webcamConfig: {
      resolution: "fullhd", // "sd" | "hd" | "fullhd"
      optimizationMode: "motion",
    },
  });

  // console.log(localParticipant)
  // console.log(participants)

  let customerParticipantId = null;
  participants.forEach((participant, id) => {
    if (!participant.local) {
      customerParticipantId = id;
    }
  });
  // console.log("Customer ID:", customerParticipantId);

  const { micStream: customerMicStream } = useParticipant(customerParticipantId);
  const [micEnabled, setMicEnabled] = useState(true);
  const [webcamEnabled, setWebcamEnabled] = useState(true);
  const [isRecording, setIsRecording] = useState(false);
  const mediaRecorderRef = useRef(null);
  const recordedChunksRef = useRef([]);
  const [screenStream, setscreenStream] = useState(null);
  const [micStream, setmicStream] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [customerAudioTracks, setcustomerAudioTracks] = useState([])
  const [mediaRecorder, setmediaRecorder] = useState(null);

  useEffect(() => {
    setMicEnabled(localParticipant?.micOn);
    setWebcamEnabled(localParticipant?.webcamOn);
    console.log("localParticipant-> ", localParticipant)
    // eslint-disable-next-line
  }, [localParticipant?.micOn, localParticipant?.webcamOn]);
  useEffect(() => {
    console.log("check->  ", micEnabled, webcamEnabled)
  }, [micEnabled, webcamEnabled])

  const startRecording = async () => {
    // console.log("MediaRecorder State:", mediaRecorder.state);
    try {

      // 1. Capture screen
      if (!localParticipant?.webcamOn) {
        toast.error("Please turn ON camera before recording");
        return;
      }

      const screenStream = await navigator.mediaDevices.getDisplayMedia({
        video: {
          width: { max: 1280 },
          height: { max: 720 },
          frameRate: { max: 55 }
        },
        audio: true,
      });
      setscreenStream(screenStream);

      // 2. Capture agent mic
      const micStream = await navigator?.mediaDevices?.getUserMedia({ audio: true });
      setmicStream(micStream);
      // 3. Capture customer mic stream
      let customerAudioTracks = [];
      if (customerMicStream && customerMicStream.track) {
        const customerAudioMediaStream = new MediaStream([customerMicStream.track]);
        customerAudioTracks = customerAudioMediaStream.getAudioTracks();
      }

      // 4. Create AudioContext to mix audio
      const audioContext = new AudioContext();
      const destination = audioContext.createMediaStreamDestination();

      // Screen audio
      const screenAudioTracks = screenStream.getAudioTracks();
      if (screenAudioTracks.length) {
        const screenSource = audioContext.createMediaStreamSource(new MediaStream(screenAudioTracks));
        screenSource.connect(destination);
      }

      // Agent mic audio
      const micAudioTracks = micStream.getAudioTracks();
      if (micAudioTracks.length) {
        const micSource = audioContext.createMediaStreamSource(new MediaStream(micAudioTracks));
        micSource.connect(destination);
      }

      // Customer mic audio
      if (customerAudioTracks.length) {
        const customerSource = audioContext.createMediaStreamSource(new MediaStream(customerAudioTracks));
        customerSource.connect(destination);
      }

      // 5. Get mixed audio track
      const mixedAudioTrack = destination.stream.getAudioTracks()[0];

      // 6. Combine screen video with mixed audio
      const combinedStream = new MediaStream([
        ...screenStream.getVideoTracks(),
        mixedAudioTrack,
      ]);

      // 7. Setup MediaRecorder
      const mediaRecorder = new MediaRecorder(combinedStream, {
        mimeType: "video/webm; codecs=vp9,opus",
      });
      recordedChunksRef.current = [];
      mediaRecorderRef.current = mediaRecorder;

      mediaRecorder.ondataavailable = (event) => {
        console.log("Chunk received", event?.data?.size);

        if (event.data.size > 0) {
          recordedChunksRef.current.push(event.data);
        }
      };

      mediaRecorder.onstop = async () => {
        console.log("========== ONSTOP START ==========");
        screenStream.getTracks().forEach((track) => track.stop());
        micStream.getTracks().forEach((track) => track.stop());
        customerAudioTracks.forEach((track) => track.stop());
        console.log("Streams stopped");

        setcustomerAudioTracks(customerAudioTracks);
        const blob = new Blob(recordedChunksRef.current, { type: "video/webm" });
        console.log("Blob created", blob.size);

        const file = new File([blob], "VideoPDRecording.webm", { type: "video/webm" });
        console.log("File created");

        const formData = new FormData();
        formData.append("video", file);
        formData.append("borrower_Id", fetchedBorrowerDetails.borrower_uniqueno);
        formData.append("loan_Id", loanID);

        console.log("FormData created");
        console.log("Before axios");

        try {
          setOpen(true);
          console.log(formData,"formData")
          await axios.post(`${url}/videosdk/screen/record`, formData, {
            headers: {
              token: Cookies.get("Token"),
              email: Cookies.get("Email"),
            },
          });
          toast.success("Video uploaded successfully!");
        } catch (err) {
          console.error("Upload error:", err);
          toast.error("Error uploading recording.");
        } finally {
          setOpen(false);
          setIsRecording(false);
          console.log("========== ONSTOP END ==========");
        }
      };

      mediaRecorder.start(5000);
      setIsRecording(true);
      setmediaRecorder(mediaRecorder);
    } catch (err) {
      console.error("Error during recording:", err);
      toast.error("Recording failed. Please allow screen and mic permissions.");
    }
  };
  // eslint-disable-next-line no-unused-vars
  async function upload_video() {
    try {
      screenStream.getTracks().forEach((track) => track.stop());
      micStream.getTracks().forEach((track) => track.stop());
      customerAudioTracks.forEach((track) => track.stop());

      const blob = new Blob(recordedChunksRef.current, { type: "video/webm" });
      const file = new File([blob], "VideoPDRecording.webm", { type: "video/webm" });

      const formData = new FormData();
      formData.append("video", file);
      formData.append("borrower_Id", fetchedBorrowerDetails.borrower_uniqueno);
      formData.append("loan_Id", loanID);

      console.log("Chunks:", recordedChunksRef?.current?.length);
      console.log("Blob Size:", blob?.size);
      console.log("File Size:", file?.size);
      console.log("Loan:", loanID);
      console.log("Borrower:", fetchedBorrowerDetails.borrower_uniqueno);
      console.log("Uploading...");

      try {
        setOpen(true);
        console.log(formData,"formData")
        await axios.post(`${url}/videosdk/screen/record`, formData, {
          headers: {
            token: Cookies.get("Token"),
            email: Cookies.get("Email"),
          },
        });
        toast.success("Video uploaded successfully!");
      } catch (err) {
        // console.error("Upload error:", err);
        // alert("Upload error:", err);
        console.log("======== Upload Failed ========");

        console.log("Message:", err?.message);
        console.log("Code:", err?.code);
        console.log("Status:", err?.response?.status);
        console.log("Response:", err?.response?.data);

        console.log("Request exists:", !!err?.request);
        console.log("Response exists:", !!err?.response);
        toast.error(`Error uploading recording: ${err}`);
      } finally {
        setOpen(false);
        setIsRecording(false);
      }


      mediaRecorder.start(5000);
      setIsRecording(true);
    } catch (error) {
      console.error("Error during recording:", error);
      toast.error(`Recording failed. Please allow screen and mic permissions: ${error}`);
      alert("Recording failed. Please allow screen and mic permissions.");
    }
  }

  const stopRecording = () => {
    console.log("Stop Recording clicked");

    if (mediaRecorderRef.current) {
      console.log("Recorder State:", mediaRecorderRef?.current?.state);

      mediaRecorderRef.current.stop();

      console.log("stop() invoked");
    } else {
      console.log("mediaRecorderRef.current is NULL");
    }
  };

  const handleLeaveMeeting = (e) => {
    leave();
    toast.error("Meeting Left");
  };

  const handleToggleMic = async () => {
    try {
      setMicEnabled(prevState => !prevState);
      await toggleMic();
    } catch (error) {
      console.error("Failed to toggle mic", error);
    }
  };

  const handleToggleWebcam = async () => {
    try {
      const track = await createCameraVideoTrack({
        encoderConfig: "h1080p_w1440p",
        optimizationMode: "motion",
        facingMode: "user",
      });

      setWebcamEnabled(prevState => !prevState);
      await toggleWebcam(track);
    } catch (error) {
      console.error("Failed to toggle webcam", error);
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  let unloading = useRef(false);

  useEffect(() => {
    // eslint-disable-next-line
    const handleBeforeUnload = (event) => {
      unloading.current = true;
      event.preventDefault();
      event.returnValue = "";
    };

    const handleFocus = () => {

      if (unloading.current) {
        console.log("User clicked STAY ");
        unloading.current = false;
      }
      // if(!unloading)
      // {
      //   if(mediaRecorderRef?.current?.state==="recording")
      //   {
      //     mediaRecorderRef.current.stop();
      //   }
      // }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("focus", handleFocus);
    // window.addEventListener("pagehide", () => {
    //   if(mediaRecorderRef?.current?.state==="recording")
    //   {
    //        mediaRecorderRef.current.stop();
    //   }
    //   alert("Page is closing or refreshing (guaranteed)");
    //   console.log("Page is closing or refreshing (guaranteed)");
    // });
    return () => {
      window?.removeEventListener("beforeunload", handleBeforeUnload);
      window?.removeEventListener("focus", handleFocus);
      unloading.current = false;
    };
    // eslint-disable-next-line
  }, []);


  return (
    <div className={styles.controlsContainer}>
      <button className={styles.leaveControls} onClick={handleLeaveMeeting}>
        End Meeting
      </button>

      <Tooltip title="Audio">
        <button className={styles.micControls} onClick={handleToggleMic}>
          {micEnabled ? <MicIcon /> : <MicOffIcon />}
        </button>
      </Tooltip>

      <Tooltip title="Webcam">
        <button className={styles.webcamControls} onClick={handleToggleWebcam}>
          {webcamEnabled ? <CameraAltIcon /> : <NoPhotographyIcon />}
        </button>
      </Tooltip>

      <button
        onClick={isRecording ? stopRecording : startRecording}
        style={{
          backgroundColor: isRecording ? "red" : "green",
          color: "white",
          padding: "12px 20px",
          borderRadius: "5px",
          border: "none",
          cursor: "pointer",
        }}
      >
        {isRecording ? "Stop Recording" : "Start Recording"}
      </button>
      <ToastContainer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}